// extracted by mini-css-extract-plugin
export default {"hr":"Hr_hr__9qciD","slide":"Hr_slide__eAn9+"};